var Vue = require('vue')
var VueRouter = require('vue-router')
var config = require('common/config')
Vue.use(VueRouter)

require('common/validators')(Vue)

require('material-design-lite/material')
// require('getmdl-select/getmdl-select.min')

var startApp = function () {
  console.log('in startApp')
  window.ga('create', config.gaKey, 'auto')
  window.ga('set', 'anonymizeIp', true)
  window.ga('send', 'pageview')
  var local = require('common/store/local')
  local.put('client.options', {
    auth: 'Basic ' + window.btoa('default:secret'),
    scope: 'default'
  })
  var router = new VueRouter({
    hashbang: false,
    history: true,
    transitionOnLoad: true
  })

  var routes = require('./routes')
  router.map(routes)
  router.beforeEach(function (transition) {
    console.log('here ', transition.to.path)
    // if (transition.to.path === '/') transition.redirect('/app')
    var drawer = document.querySelector('.mdl-layout').MaterialLayout ? document.querySelector('.mdl-layout').MaterialLayout.drawer_ : null
    var overlay = document.querySelector('.mdl-layout__obfuscator')
    // Set accessibility properties.
    if (drawer) drawer.classList.remove('is-visible')
    if (overlay) overlay.classList.remove('is-visible')

    var local = require('common/store/local')

    window.document.getElementById('scroll-tab').scrollTop = 0

    if (transition.to.auth === 'private' && !local.get('client.logged')) {
      transition.redirect('/app/login')
      return
    }
    if (transition.to.auth === 'public' && local.get('client.logged') && transition.to.path.indexOf('/app/payment') !== 0) {
      transition.redirect('/app/managed')
      return
    }

    transition.next()
  })
  router.afterEach(function (from) {
    window.ga('set', 'page', from.to.path)
    window.ga('send', 'pageview')
  })
  var app = require('./App')
  // ga(router, config.gaKey)
  router.start(app, 'app')
  window.document.querySelector('#loading').style.display = 'none'
}
// lang from url
var mainSiteLang = 'en'

if (navigator) {
  if (navigator.language) {
    mainSiteLang = navigator.language.split('-')[0].toLowerCase()
  }
}

var storedLang = require('common/store/local').get('client.language')
if (storedLang) {
  mainSiteLang = storedLang
} else if (window.location.href.split('lang=').length > 1) {
  mainSiteLang = window.location.href.split('lang=')[1].split('&')[0]
}
if (!['ar', 'es', 'it', 'fr', 'de', 'en', 'ja', 'ru', 'zh', 'ko'].includes(mainSiteLang)) {
  mainSiteLang = 'en'
}
require('api/init')(mainSiteLang, function (data) {
  var local = require('../common/store/local')
  local.put('client.language', mainSiteLang)
  return data
}).then(function (data) {
  console.log('register filters')
  var filters = require('common/filters')(data)

  Vue.filter('label', filters.label)
  Vue.filter('lookup', filters.lookup)
  Vue.filter('lookupValue', filters.lookupValue)
  Vue.filter('lookupLabel', filters.lookupLabel)
  Vue.filter('makeDate', filters.makeDate)
  Vue.filter('appConfig', filters.appConfig)
}).then(startApp)



// WEBPACK FOOTER //
// ./src/client/index.js